<template xmlns:wx="http://www.w3.org/1999/xhtml">
  <div class="root">
    <div class="called-list-container" v-if="calledList.recordList.length > 0">
      <div class="called-box" v-for="(item,index) in calledList.recordList" @click="gotoDetail(item, index)"
           v-bind:id="index">
        <div class="left-box">
          <div class="people-img-box">
            <template v-if="item.mark && item.mark.tagType > 0">
              <img v-if="item.mark.tagType == 50" src="@/assets/icon_srdh.png"></img>
              <img v-else-if="item.mark.tagType == 51" src="@/assets/icon_fczj.png"></img>
              <img v-else-if="item.mark.tagType == 52" src="@/assets/icon_bxlc.png"></img>
              <img v-else-if="item.mark.tagType == 53" src="@/assets/icon_ggtx.png"></img>
              <img v-else-if="item.mark.tagType == 54" src="@/assets/icon_zpdh.png"></img>
              <img v-else-if="item.mark.tagType == 55" src="@/assets/icon_kdwm.png"></img>
              <img v-else-if="item.mark.tagType == 56" src="@/assets/icon_czc.png"></img>
              <img v-else src="@/assets/called.png"></img>
            </template>
            <template v-else>
              <img src="@/assets/called.png"></img>
            </template>
          </div>
        </div>

        <div class="circle" v-if="item.readStatus == 0"></div>

        <div class="right-box">
          <div class="right-top-box">
            <div class="phone">
              {{ item.contactInfo && item.contactInfo.name ? item.contactInfo.name : item.callKey.callerPhoneNum }}
            </div>
            <template v-if="item.mark && item.mark.tagType > 0">
              <div v-if="item.mark.tagType == 50" class="phone-tag negative-phone-tag">骚扰电话</div>
              <div v-else-if="item.mark.tagType == 51" class="phone-tag negative-phone-tag">房产中介</div>
              <div v-else-if="item.mark.tagType == 52" class="phone-tag positive-phone-tag">保险理财</div>
              <div v-else-if="item.mark.tagType == 53" class="phone-tag negative-phone-tag">广告推销</div>
              <div v-else-if="item.mark.tagType == 54" class="phone-tag negative-phone-tag">诈骗电话</div>
              <div v-else-if="item.mark.tagType == 55" class="phone-tag positive-phone-tag">快递外卖</div>
              <div v-else-if="item.mark.tagType == 56" class="phone-tag positive-phone-tag">出租车</div>
            </template>
            <div style="flex: 1"></div>
            <img class="close_icon" src="@/assets/icon_close.png" v-if="item.isexample" @click="del($event, item)">
            <div class="date" v-else>{{ item.startTimeText }}</div>
          </div>
          <div class="msg">{{ item.firstMsg || '(对方无应答)' }}</div>
        </div>

        <div class="called-box-divider"></div>
      </div>

    </div>
    <!--      <div class="empty" v-if="calledList.recordList.length == 0">-->
    <!--        <img class="empty_icon" src="@/assets/list_empty.png"></img>-->
    <!--        <div class="empty_tips">暂无通话记录</div>-->
    <!--      </div>-->
  </div>
</template>

<script>
import lubanapi from '@/lubanapi'

export default {
  name: 'CallList',
  data () {
    return {
      cardTipmsg: '会员享无限次使用等24项特权'
    }
  },
  props: {
    calledList: {
      type: Object,
      default: {
        isFinished: true,
        recordList: [],
        result: 0,
        totalRecord: 0,
        totalTime: 0,
      }
    },
  },
  methods: {
    gotoDetail (item, id) {
      console.log('gotoDetail', JSON.stringify(id))
      if (item.isexample) {
        this.$router.push({
          path: '/calldetail?exampleNum=' + item.callKey.callerPhoneNum
        })
      } else {
        this.$router.push({
          path: '/calldetail?id=' + id
        })
      }
      // window.location.href = '#/calldetail?id=' + id
      lubanapi.reportseer('AICall_Home_Page_Bill_Click')
    },
    del (event, item) {
      event.stopPropagation()
      this.$emit('delItem', item)
    }
  }
}
</script>
<style scoped>
.vip_head_layout {
  display: flex;
  flex-direction: column;
  align-items: center; /* 垂直居中 */
  height: 13rem;
  width: 100%;
  background: #F7F7F9;
}

.vip_tip_layout {
  width: 100%;
  height: 3.03rem;
  background: #42b983;
  align-items: center;
  position: relative;
}

.vip_tip_icon {
  position: absolute;
  width: 2.5rem;
  height: 2.5rem;
  background: #BFBFBF;
  border-radius: 1.25rem;
  top: 50%;
  transform: translate(0, -50%);
}

.vip_tip_icon img {
  position: absolute;
  width: 1.905rem;
  height: 1.905rem;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.vip_tip_text_back {
  position: absolute;
  min-width: 5rem;
  max-width: 20rem;

  height: 2rem;
  left: 3.5rem;
  border-radius: 0.2rem;
  top: 50%;
  transform: translate(0, -50%);
  background: #3265E4;

  color: white;
  font-size: 0.8rem;
  font-family: PingFangSC-Regular;
  word-break: break-all;
  line-height: 2rem;
  white-space: nowrap;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.vip_tip_text_back:after {
  content: '';
  position: absolute;
  right: 100%;
  top: 50%;
  transform: translate(0, -50%);
  width: 0;
  height: 0;
  border-width: 0.3rem;
  border-style: solid;
  border-color: transparent;
  border-right-width: 0.5rem;
  border-right-color: currentColor;
  color: #3265E4;
}

.vip_card_layout {
  width: 100%;
  height: 8.15rem;
  border-radius: 8px 8px 0px 0px;
  margin-top: 1rem;

  display: flex;
  flex-direction: column;
  align-items: center; /* 垂直居中 */

  background-image: linear-gradient(134deg, #26282D 0%, #111118 100%);
}

.vip_card_layout1 {
  width: 100%;
  position: relative;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  box-sizing: border-box;
}

.vip_card_layout2 {
  width: 100%;
  position: relative;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  box-sizing: border-box;

  display: flex;
  flex-direction: row;
  align-items: center; /* 垂直居中 */
}

.vip_tip_msg {
  font-family: PingFangSC-Regular;
  font-size: 1rem;
  color: #FFFFFF;
  letter-spacing: 0;
  float: left;
}

.vip_open_button {
  width: 4.4rem;
  height: 1.7rem;
  background-image: linear-gradient(45deg, #FFF3C8 0%, #FFCB84 100%);
  border-radius: 27px;

  font-family: PingFangSC-Medium;
  font-size: 0.815rem;
  line-height: 1.7rem;
  line-height: 1.7rem;
  color: #3B3C42;
  letter-spacing: 0;
  text-align: center;
  float: right;
}

.card_setting_item {
  flex: 1;
}


.card_setting_item img {
  width: 1.9rem;
  height: 1.9rem;
  border-radius: 0.95rem;
  background-image: linear-gradient(134deg, #3B3D42 0%, #1F2029 100%);
}

.card_setting_item_title {
  opacity: 0.7;
  font-family: PingFangSC-Regular;
  font-size: 0.7rem;
  color: #FFFFFF;
  text-align: center;
  margin-top: 0.5rem;
}

.empty {
  width: 100%;
  height: 100%;
  background: #F7F7F9;
}

.empty_icon {
  width: 2.9rem;
  height: 2.9rem;
  opacity: 0.41;
  margin-top: 5rem;
}

.empty_tips {
  margin-top: 1.5rem;
  font-size: 1rem;
  color: #000000;
  text-align: center;
}

.called-box {
  position: relative;
  width: 100%;
  height: 4.4rem;
  box-sizing: border-box;
  /*border-bottom: 0.01rem solid #DDDDDD;*/
  background: #ffffff;
}

.called-box-divider {
  position: absolute;
  width: calc(100% - 4rem);
  height: 0.6px;
  background: #DDDDDD;
  bottom: 0;
  left: 4rem;
}

.called-box .left-box {
  position: relative;
  width: 4rem;
  height: 4rem;
  box-sizing: border-box;
}

.called-box .left-box img {
  position: absolute;
  top: 50%;
  transform: translateY(-47%);
  left: 0.8rem;
  width: 2.5rem;
  height: 2.5rem;
}

.called-box .right-box {
  position: absolute;
  width: calc(100% - 4rem - 0.8rem);
  height: 4rem;
  top: 0px;
  right: 0.8rem;
  margin-top: 0.55rem;
  box-sizing: border-box;
}

.called-box .right-box .right-top-box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 1.41rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}

.called-box .right-box .right-top-box .phone {
  float: left;
  width: auto;
  text-align: left;
  max-width: 9rem;
  color: #151515;
  text-align: left;
  font-size: 1rem;
  height: 1.41rem;
  line-height: 1.41rem;
  font-family: PingFangSC-Medium;
  color: #000000;
  letter-spacing: 0;
  white-space: nowrap;
  overflow: hidden;
  /*text-overflow:ellipsis;*/

  border: 1px solid transparent;
  box-sizing: border-box;
}

.called-box .right-box .right-top-box .phone-tag {
  float: left;
  margin-left: 0.3rem;
  width: auto;
  height: 1rem;
  line-height: 1rem;
  border: 0.05rem solid #FFB300;
  /*border-radius: 0.2rem;*/
  padding-left: 0.2rem;
  padding-right: 0.2rem;
  background: #fff;
  font-size: 0.7rem;
  color: #FFB300;
  box-sizing: border-box;
}

.negative-phone-tag {

}

.close_icon {
  width: 1.2rem;
  height: 1.2rem;
  padding: 0.28rem;
  box-sizing: border-box;
  font-family: PingFangSC-Regular;
}

.called-box .right-box .right-top-box .date {
  top: 0;
  right: 0;
  width: auto;
  height: 1rem;
  line-height: 1rem;
  font-family: PingFangSC-Regular;
  font-size: 0.75rem;
  color: #999999;
  letter-spacing: 0;
  text-align: right;

  border: 1px solid transparent;
  box-sizing: border-box;
}

.called-box .right-box .msg {
  position: absolute;
  left: 0;
  width: auto;
  font-size: 28px;
  color: #151515;
  text-align: left;
  word-break: break-all;
  overflow: hidden;

  top: 1.65rem;
  max-width: 100%;
  height: 1.25rem;
  line-height: 1.25rem;
  font-family: PingFangSC-Regular;
  font-size: 0.8rem;
  color: #999999;
  letter-spacing: 0;
}

.called-box .circle {
  position: absolute;
  top: 20%;
  left: 3rem;
  width: 0.5rem;
  height: 0.5rem;
  background: #FF7373;
  border-radius: 50%;
}

.called-list-container {
  width: 100%;
  position: relative;
}

.root {
  width: 100%;
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/widgets/CallList.vue